"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Clamp a value to ensure it falls within a given range. */
function clamp(value, max, min) {
    if (min === void 0) { min = 0; }
    return value < min ? min : value > max ? max : value;
}
exports.clamp = clamp;
//# sourceMappingURL=clamp.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/utilities/color/clamp.js
// module id = 801
// module chunks = 0